import React from 'react'
import './AIContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaBrain, FaSearch, FaCog, FaChartBar } from 'react-icons/fa'

export class AIContent extends React.Component {
  render() {
    return (
      <div className="ai-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner has deployed production-grade AI systems in federal
            environments where scale, compliance, and real-time performance are
            mission-critical - from FDA regulatory review to Air Force mobility
            planning and DoD command and control.
          </div>
        </div>

        <section className="padding-large">
          <h2>Featured Deployments</h2>
          <div className="row">
            <div className="col-md-4">
              <div className="deployment-card">
                <div className="org">FDA CDRH</div>
                <div className="title">AI-Assisted Document Analysis</div>
                <div className="description">
                  Built and deployed an AI platform for document summarization,
                  data extraction, and automated review workflows using LLMs, OCR
                  pipelines, and RAG in AWS GovCloud with full PIV/CAC SSO and
                  organizational data isolation.
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="deployment-card">
                <div className="org">Air Mobility Command</div>
                <div className="title">NITMRE-NLP</div>
                <div className="description">
                  Deployed AI/ML infrastructure for generative AI and NLP models
                  supporting mobility planning with RAG pipelines and ChatOps
                  tools - featured in Air Force Chief of Staff General David Allvin's
                  keynote at Sea, Air, Space 2025.
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="deployment-card">
                <div className="org">Air Force Shadow Ops Center</div>
                <div className="title">REAPER C2 AI Platform</div>
                <div className="description">
                  Achieved TRL 7 with AI-enabled decision support for command and
                  control operators, demonstrating 2x improvement in decision speed
                  with explainable AI frameworks maintaining human control.
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Core Capabilities</h2>
          <div className="row capabilities-list">
            <div className="col-md-6">
              <div className="capability-item">
                <div className="icon"><FaBrain /></div>
                <div className="content">
                  <div className="title">Large Language Models</div>
                  <div className="description">
                    Integration and fine-tuning of open-source models (GPT-oss,
                    Mistral, Llama) for deployment in secure local environments
                    (LLMSecOps)
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-item">
                <div className="icon"><FaSearch /></div>
                <div className="content">
                  <div className="title">Retrieval-Augmented Generation</div>
                  <div className="description">
                    RAG pipelines for context-aware responses using organizational
                    data while maintaining security and access controls
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-item">
                <div className="icon"><FaCog /></div>
                <div className="content">
                  <div className="title">MLOps Practices</div>
                  <div className="description">
                    End-to-end ML lifecycle management ensuring reliability,
                    auditability, and rapid iteration with automated retraining
                    and deployment
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-item">
                <div className="icon"><FaChartBar /></div>
                <div className="content">
                  <div className="title">Explainable AI</div>
                  <div className="description">
                    Implementation of LIME and SHAP frameworks to make AI
                    reasoning transparent and maintain human-in-the-loop decision
                    authority
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Secure, Compliant AI</h2>
          <div className="security-grid">
            <div className="security-item">
              <h3>Private VPC Deployment</h3>
              <p>
                All AI workloads deployed in fully private VPCs with no internet
                egress, ensuring sensitive data never leaves your environment.
              </p>
            </div>
            <div className="security-item">
              <h3>Access Control</h3>
              <p>
                Strict RBAC, PIV/CAC SSO, and organizational data isolation to
                protect sensitive information and maintain audit trails.
              </p>
            </div>
            <div className="security-item">
              <h3>Inference Optimization</h3>
              <p>
                Real-time performance optimization for mission-critical
                applications requiring low-latency responses at scale.
              </p>
            </div>
            <div className="security-item">
              <h3>Hybrid Approaches</h3>
              <p>
                Combine rule-based logic with machine learning for reliability and
                explainability in high-stakes decision environments.
              </p>
            </div>
            <div className="security-item">
              <h3>Frontier Model Adoption</h3>
              <p>
                Securely integrate frontier LLMs from OpenAI, Anthropic, and Google
                into your workflows with proper guardrails, compliance controls, and
                data protection.
              </p>
            </div>
          </div>
        </section>

        <div className="split">
          <div className="cta-section">
            <h2>Transform Your Operations with AI</h2>
            <p>
              Let Rackner bring production-grade AI capabilities to your
              mission-critical federal systems.
            </p>
            <div className="button-wrap">
              <Link to="/reaper">
                <button className="btn-raised-light-blue-inverse big">
                  Explore REAPER AI Platform
                </button>
              </Link>
            </div>
          </div>
        </div>

        <CallToActionBanner route={'contact'} linkText={'Get Started'} />
      </div>
    )
  }
}

export default AIContent
